const events = ['onTaskAssignedToMe']
const operators = ['>', '<', '>=', '<=', '==', '!=']
const logicalOperators = ['AND', 'OR']
const conditions = ['IF', 'ELSE IF', 'ELSE']
const fns = [
  {
    name: 'vote',
    example: `
vote("Vote Name")
vote("Send Next") # refer vote tab for available votes
    `,
    docs: 'Triggers a configured vote / navigation action.',
  },
  {
    name: 'approve_all',
    example: `
approve_all("Field level comments")
approve_all("Approved as per policy")
    `,
    docs: 'Approves all fields/items with a common approval comment.',
  },
  {
    name: 'approve_all_except',
    example: `
approve_all_except([amount], "All other fields approved")
approve_all_except([amount, tax], "Need review on excluded fields") # pass array of variableFieldKey
    `,
    docs: 'Approves everything except provided fields.',
  },
  {
    name: 'approve_one',
    example: `
approve_one(variableFieldKey, "Looks good")
approve_one(amount, "Amount verified") # refer variables tab for available variableFieldKey
    `,
    docs: 'Approves only one specific field using field key.',
  },
  {
    name: 'reject_all',
    example: `
reject_all("Multiple issues found")
reject_all("Mandatory details missing")
    `,
    docs: 'Rejects all fields/items with common rejection reason.',
  },

  {
    name: 'reject_all_except',
    example: `
reject_all_except([amount], "All other fields rejected")
reject_all_except([amount, tax], "Only selected fields are acceptable") # pass array of variableFieldKey
    `,
    docs: 'Rejects everything except provided fields.',
  },

  {
    name: 'reject_one',
    example: `
reject_one(variableFieldKey, "Incorrect value")
reject_one(amount, "It is too high") # refer variables tab for available variableFieldKey
    `,
    docs: 'Rejects only one specific field with reason.',
  },
]

const examples = `# Allowed Triggers: ${events.join(', ')}
# Allowed Operators: ${operators.join(', ')}
# Allowed Blocks: ${conditions.join(', ')}
# Allowed Logical Operators: ${logicalOperators.join(', ')}


#1 Basic Approval / Rejection Flow (full line comments)
IF amount < 100000 AND project == "Hub-02" # Inline comments
THEN
  approve_all("Within limit and valid project")

ELSE
  reject_one("amount", "Amount exceeds allowed limit")
  vote("Send Back")


#2 Multi-Level Condition
IF amount > 10000
THEN
  approve_all("High value request approved")

ELSE IF project == "Hub-02"
THEN
  approve_all("Approved for Hub-02 project")

ELSE
  reject_one("amount", "Request does not meet approval rules")


#3 Simple AND Condition
IF amount > 1000 AND project == "Hub"
THEN
  approve_all("Amount and project matched")


#4 AND + OR with Grouping
IF amount > 1000 AND (project == "Hub" OR budget > 0)
THEN
  approve_all("Eligible by project or budget")


#5 OR with Nested AND
IF (amount > 1000 AND project == "Hub") OR budget > 0
THEN
  approve_all("Eligible through primary or fallback condition")


#6 Extra Parentheses Supported
IF ((amount > 1000))
THEN
  approve_all("Amount condition passed")


#7 Reject All Example
IF amount > 500000
THEN
  reject_all("Amount exceeds maximum allowed threshold")


#8 Approve One Field Only
IF amount <= 50000
THEN
  approve_one("amount", "Amount is acceptable")


#9 Reject All Except Selected Fields
IF project != "Hub-02"
THEN
  reject_all_except(["amount"], "Only amount remains valid")


#10 Approve All Except Selected Fields
IF budget > 0
THEN
  approve_all_except(["remarks"], "All core fields approved")


#11 Use of Parentheses and Comments

# Full line comments
IF
  ((amount <= 20000 OR project == "hub-02") # Inline comments
  AND name = "Nitish Kumar")
THEN
  approve_all("Permissible Amount")
  vote("Send Next")

ELSE IF
  project == "hub-02"
THEN
  approve_all("No limit for Hub-02")
  vote("Send Next")

ELSE
  reject_one(amount, "To high")
  vote("Send Back")
`

const placeholder = `IF amount > 10000
THEN
  approve_all("high")

ELSE IF project == "hub-02"
THEN
  approve_all("hub")

ELSE
  reject_one("amount", "invalid")
`

module.exports = { examples, placeholder, events, operators, logicalOperators, conditions, fns }
